import filter from 'lodash/filter.js';
import includes from 'lodash/includes.js';

const getSelectedChoices = (options, choices) => {
  const isSkuMapped = option => (
    !includes(option.tags, 'notskumapped')
    ||
    includes(option.tags, 'category-quantity')
  );

  return filter(
    choices,
    choice =>
      options[choice.optionId].isActive &&
      choice.isSelected &&
      isSkuMapped(options[choice.optionId]),
  );
};

export default getSelectedChoices;
